import React, { useState, useEffect } from 'react';

import { Segment, Button, Container, Image, Form } from 'semantic-ui-react';

import _get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';

import {
  INTEGRATION_PROVIDER,
  INTEGRATION_PROVIDER_SERVICE_TYPE,
  DEFAULT_SERVICE_DATA,
  ACCOUNT_ID_KEY,
} from './DaySmart.constants';
import { isDaySmartIntegrationAllowed } from './DaySmart.utils';
import {
  updateProviderServiceSetting,
  addNewProviderServiceSetting,
  deleteProviderServiceSetting,
} from '../../../../actions/business';
import API from '../../../../libs/api';
import { InlineFieldContainer } from '../../../common';
import FormContainer from '../../../common/FormContainer';
import FormInput from '../components/FormInput';
import { getProviderService, getProviderServiceSettingById } from '../utils';

import DaySmartLogo from '../../../../static/logos/daysmart.png';

import './DaySmart.scss';

const propTypes = {};

const defaultProps = {};

function DaysmartIntegration() {
  const dispatch = useDispatch();
  const business = useSelector((state) => _get(state.business, 'core.value'));
  const providerServices = useSelector((state) => _get(state.business, 'provider_services.value'));
  const providerServiceSettings = useSelector((state) =>
    _get(state.business, 'provider_service_settings.value'),
  );

  const { id: businessId, type: businessType } = business;

  const daysmartService = getProviderService(
    providerServices,
    INTEGRATION_PROVIDER,
    INTEGRATION_PROVIDER_SERVICE_TYPE,
  );

  if (!daysmartService || !isDaySmartIntegrationAllowed(business)) {
    return null;
  }

  const daysmartSetting = getProviderServiceSettingById(
    providerServiceSettings,
    daysmartService.id,
  );
  const daysmartServiceData = daysmartSetting ? daysmartSetting.service_data : DEFAULT_SERVICE_DATA;

  const [serviceData, setServiceData] = useState(daysmartServiceData);
  const accountId = _get(serviceData, ACCOUNT_ID_KEY);

  async function addIntegration() {
    dispatch(
      addNewProviderServiceSetting({
        provider_service: daysmartService.id,
        provider: daysmartService.provider,
        service_type: daysmartService.service_type,
        service_data_schema: daysmartService.service_data_schema,
        service_data: {},
        status_data: {},
      }),
    );
  }

  function handleUpdate(e, { value, name }) {
    setServiceData({
      ...serviceData,
      [name]: value,
    });
  }

  async function removeIntegration() {
    await API.deleteProviderServiceSettings(businessId, businessType, daysmartSetting.id);
    dispatch(
      deleteProviderServiceSetting({
        fields: {
          index: daysmartSetting.globalIndex,
          ignoreTouch: true,
        },
      }),
    );
    setServiceData({});
  }

  useEffect(() => {
    if (!daysmartSetting) return;

    const updatedProviderServiceSettingPayload = {
      index: daysmartSetting.globalIndex,
      field: 'service_data',
      fieldValue: { ...serviceData },
    };

    dispatch(updateProviderServiceSetting(updatedProviderServiceSettingPayload));
  }, [serviceData]);

  return (
    <FormContainer loadedKeyPath={['business', 'provider_service_settings']}>
      <InlineFieldContainer title={<h2>DaySmart</h2>} enableDelete={false}>
        <Segment.Group>
          <Segment>
            <Container>
              <Container textAlign="center">
                <Image src={DaySmartLogo} className="daysmart-integration-logo" />
              </Container>
            </Container>
          </Segment>
          {daysmartSetting ? (
            <>
              <Segment attached="top">
                <Form>
                  <FormInput
                    value={accountId}
                    name={ACCOUNT_ID_KEY}
                    label="Account ID"
                    handleUpdate={handleUpdate}
                  />
                </Form>
              </Segment>
              {daysmartSetting.id && (
                <Segment attached="bottom">
                  <Container textAlign="center">
                    <Button size="big" onClick={removeIntegration} negative>
                      Remove Integration
                    </Button>
                  </Container>
                </Segment>
              )}
            </>
          ) : (
            <Segment attached="top">
              <Container textAlign="center">
                <Button size="big" onClick={addIntegration} primary>
                  Setup Integration
                </Button>
              </Container>
            </Segment>
          )}
        </Segment.Group>
      </InlineFieldContainer>
    </FormContainer>
  );
}

DaysmartIntegration.propTypes = propTypes;
DaysmartIntegration.defaultProps = defaultProps;

export default DaysmartIntegration;
